<template>
    <vue-table-card title="Course Syllabus" :show-search-box="false" :fields="fields"
                    :url="listUrl" :per-page="10" ref="table" :extra-params="{course: id}">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn size="xs" text="View" @click="setEdit(rowData)"/>
                <delete-btn v-if="!checkIfPublished" @click="setDelete(rowData)"/>
            </div>
        </template>

        <template #footer>
            <modal title="Course Syllabus" ref="addModal" width="40r" header-color="primary" no-close-on-backdrop>
                <add-course-syllabus @success="formSuccess" :course="id"/>
            </modal>

            <modal title="Course Syllabus" ref="editModal" width="40r" header-color="primary" no-close-on-backdrop>
                <edit-course-syllabus :checkIfPublished="checkIfPublished" :initial-data="editingItem" :course="id" @success="formSuccess"/>
            </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the item <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
                </p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '../../../../data/urls';
import AddCourseSyllabus from './AddCourseSyllabus';
import EditCourseSyllabus from './EditCourseSyllabus';

export default {
    name: 'CourseSyllabus',
    props: {
        checkIfPublished: { type: Boolean, default: false }
    },
    components: { EditCourseSyllabus, AddCourseSyllabus },
    data () {
        return {
            id: this.$route.params.id,
            listUrl: urls.admin.course.detailsUrl.syllabus.list,
            addUrl: urls.admin.course.detailsUrl.syllabus.addEdit,
            deleteUrl: urls.admin.course.detailsUrl.syllabus.delete,
            editingItem: null,
            deletingItem: null,
            fields: [
                {
                    name: 'topic',
                    sortField: 'topic',
                    title: 'Topic'
                },
                {
                    name: 'theory',
                    sortField: 'theory',
                    title: 'Theory'
                },
                {
                    name: 'practical',
                    sortField: 'practical',
                    title: 'Practical'
                },
                {
                    name: '__slot:actions',
                    titleClass: 'center aligned text-right',
                    dataClass: 'aligned text-right'
                }
            ]
        };
    },
    methods: {
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            const refs = this.$refs;
            refs.addModal.close();
            refs.editModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.editingItem.course = this.id;
            this.$refs.editModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>
